/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetDateRangeRequest } from './WidgetDateRangeRequest';
import {
    WidgetDateRangeRequestFromJSON,
    WidgetDateRangeRequestFromJSONTyped,
    WidgetDateRangeRequestToJSON,
    WidgetDateRangeRequestToJSONTyped,
} from './WidgetDateRangeRequest';

/**
 * 
 * @export
 * @interface WidgetDateRangePreset
 */
export interface WidgetDateRangePreset extends WidgetDateRangeRequest {
    /**
     * 
     * @type {string}
     * @memberof WidgetDateRangePreset
     */
    mode: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetDateRangePreset
     */
    days?: string;
}

/**
 * Check if a given object implements the WidgetDateRangePreset interface.
 */
export function instanceOfWidgetDateRangePreset(value: object): value is WidgetDateRangePreset {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    return true;
}

export function WidgetDateRangePresetFromJSON(json: any): WidgetDateRangePreset {
    return WidgetDateRangePresetFromJSONTyped(json, false);
}

export function WidgetDateRangePresetFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDateRangePreset {
    if (json == null) {
        return json;
    }
    return {
        ...WidgetDateRangeRequestFromJSONTyped(json, true),
        'mode': json['mode'],
        'days': json['days'] == null ? undefined : json['days'],
    };
}

export function WidgetDateRangePresetToJSON(json: any): WidgetDateRangePreset {
    return WidgetDateRangePresetToJSONTyped(json, false);
}

export function WidgetDateRangePresetToJSONTyped(value?: WidgetDateRangePreset | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...WidgetDateRangeRequestToJSONTyped(value, true),
        'mode': value['mode'],
        'days': value['days'],
    };
}

